// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3PWSO","buttons":"Footer_buttons__AqOWM"};